"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

function text2vdom(text, customComponents) {
  if (customComponents === void 0) {
    customComponents = {};
  }

  var parse = require('./parser').parse;

  return React.createElement.apply(React, [React.Fragment, null].concat(parse(text, {
    customComponents: customComponents
  })));
}

exports.default = text2vdom;